import data from './combined-rv-data.json.js';

/** made from the following IFC files
 * - UK2 units
 * - Facade & Roofs
 * */
const CombinedRvData = data;

export { CombinedRvData };
//# sourceMappingURL=combined-rv-data.js.map
